/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Full_NameInputs */

const en_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Name`)
};

const de_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollstaendiger Name`)
};

const fr_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom complet`)
};

const es_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo`)
};

const it_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo`)
};

const nl_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige naam`)
};

const pl_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imie i nazwisko`)
};

const fi_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koko nimi`)
};

const da_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulde navn`)
};

const sv_resume_editor_full_name = /** @type {(inputs: Resume_Editor_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullstandigt namn`)
};

/**
* | output |
* | --- |
* | "Full Name" |
*
* @param {Resume_Editor_Full_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_full_name = /** @type {((inputs?: Resume_Editor_Full_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Full_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_full_name(inputs)
	if (locale === "fr") return fr_resume_editor_full_name(inputs)
	if (locale === "es") return es_resume_editor_full_name(inputs)
	if (locale === "it") return it_resume_editor_full_name(inputs)
	if (locale === "nl") return nl_resume_editor_full_name(inputs)
	if (locale === "pl") return pl_resume_editor_full_name(inputs)
	if (locale === "fi") return fi_resume_editor_full_name(inputs)
	if (locale === "da") return da_resume_editor_full_name(inputs)
	if (locale === "sv") return sv_resume_editor_full_name(inputs)
	return en_resume_editor_full_name(inputs)
});